var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFoldersFolderHeartFavorite = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.6667 53.3333H50.6667C53.6122 53.3333 56 50.9455 56 48V23.84C56 20.8945 53.6122 18.5067 50.6667 18.5067H33.411C32.5283 18.5067 31.7028 18.0699 31.2063 17.3401L27.4596 11.8332C26.9631 11.1034 26.1375 10.6666 25.2548 10.6667H13.3333C10.3878 10.6667 8 13.0545 8 16V32",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5009 42.862L16.0289 43.398L16.5569 42.8619C17.5196 41.8839 18.8345 41.3332 20.2068 41.3332C21.5791 41.3332 22.8939 41.8839 23.8566 42.8619V42.8619C25.8641 44.9248 25.8641 48.211 23.8566 50.274L19.7541 54.4397C18.7716 55.4379 17.4295 56 16.0289 56C14.6282 56 13.2862 55.4379 12.3036 54.4397L8.20115 50.2742C6.19369 48.2112 6.19369 44.925 8.20115 42.862V42.862C9.16382 41.884 10.4787 41.3333 11.851 41.3333C13.2233 41.3333 14.5383 41.884 15.5009 42.862Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFoldersFolderHeartFavorite);
export default ForwardRef;